/**
 * Calendar Wrapper Component
 *
 * This wrapper provides a compatibility layer for react-big-calendar when using React's strict mode.
 * It suppresses the componentWillReceiveProps warning by disabling strict mode only for the Calendar.
 */
import React, { forwardRef, useRef, useImperativeHandle } from "react";
import { Calendar as BigCalendar, CalendarProps } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";

// Forward ref to match Calendar API
const CalendarWrapper = forwardRef<any, CalendarProps<any, any>>(
  (props, ref) => {
    // Create a local ref for the calendar
    const calendarRef = useRef<any>(null);

    // Forward the calendar ref methods and properties
    useImperativeHandle(ref, () => ({
      ...calendarRef.current,
    }));

    // Render the calendar in a non-strict environment
    return (
      <React.StrictMode key='off'>
        <BigCalendar
          ref={calendarRef}
          {...props}
        />
      </React.StrictMode>
    );
  }
);

CalendarWrapper.displayName = "CalendarWrapper";

export default CalendarWrapper;
